import promotionsCategory from "./components/promotions-category/index.vue";
import promotionsProduct from "@/modules/promotions/components/promotions-product/index.vue";
import { directive as onClickaway } from "vue-clickaway";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { globalLoader } from "../../helpers/variables";
import raffleBanner from "@/assets/img/raffle/raffle-banner.jpg";

export default {
  name: "promotions",
  directives: { onClickaway },
  data() {
    return {
      raffleBanner,
      openCategory: false,
      selectedBrand: null,
      paginator: { hasNextPage: false, page: 1, perPage: 6, brand: 1, paginationLoading: false },
    };
  },
  components: { promotionsCategory, promotionsProduct },
  async created() {
    globalLoader(true);
    await this.loadProducts();
    await this.loadBrands();
    globalLoader(false);
  },
  computed: {
    ...mapGetters({
      promotionsProducts: "promotions/promotionsProducts",
      promotionsBrands: "brands/promotionsBrands",
      loadingBrands: "brands/loadingBrands",
    }),
  },
  methods: {
    ...mapActions({
      fetchPromotionsProducts: "promotions/FETCH_PROMOTIONS_PRODUCTS",
      fetchPromotionsBrands: "brands/FETCH_PROMOTIONS_BRANDS",
    }),
    ...mapMutations({
      showTextInfoModal: "popups/CHANGE_TEXT_INFO_MODAL",
    }),
    showRaffleRules() {
      this.showTextInfoModal({
        status: true,
        data: {
          width: 800,
          className: "raffle-rules",
          button: { label: "До каталогу", to: { name: "products" } },
          title: "ЩЕДРОВТЕНЬ у SkinOn 🍂🎁",
          detail: `
            <p>Кожні повні 5 000 грн в одному чеку = 1 квиток для участі в розіграші. Чим більша сума замовлення — тим більше квитків і шансів виграти один із 50 подарунків.</p>
            <p>Серед призів: 5 iPhone 18 Pro/Pro Max, 5 AirPods Pro 3, 4 комплекти iPad Air + Apple Pencil, 5 Dyson Airwrap, 5 Apple Watch SE 3, 2 розумні окуляри Meta Starfire Kylie Edition, фотоепілятор Philips, 3 телевізори та 20 наборів косметики RENEW, ALPHASCIENCE і GENIDENTITY.</p>
            <p><b>Умови акції</b></p>
            <ul>
              <li>Акція діє з 1 по 31 жовтня.</li>
              <li>1 квиток за кожні повні 5 000 грн в одному чеку.</li>
              <li>Максимум — 20 квитків на одного учасника за весь період акції.</li>
              <li>Квитки рахуються від фінальної суми чека після застосування знижок і промокодів.</li>
              <li>Суми різних замовлень між собою не сумуються.</li>
            </ul>
            <p class="raffle-rules__final">🎉 3 листопада відбудеться грандіозне оголошення переможців у прямому ефірі!</p>
          `,
        },
      });
    },
    async selectBrand(brand) {
      this.selectedBrand = brand;
      this.paginator.perPage = 6;
      await this.loadProducts();
      this.openCategory = false;
    },

    async loadProducts(page, perPage) {
      try {
        const response = await this.fetchPromotionsProducts({ page, perPage, brand: this.selectedBrand?.id });
        this.paginator.hasNextPage = !!response.links.next;
        console.log("Продукти акцій успішно завантажено");
      } catch (error) {
        console.error("Помилка при завантаженні продуктів акцій:", error);
      } finally {
        this.paginator.paginationLoading = false;
      }
    },

    async loadNextPage() {
      this.paginator.perPage += 6;
      this.paginator.paginationLoading = true;
      await this.loadProducts(this.paginator.page, this.paginator.perPage);
    },

    async loadBrands() {
      await this.fetchPromotionsBrands()
        .then(() => {
          console.log("Бренди акцій успішно завантажено");
        })
        .catch(error => {
          console.error("Помилка при завантаженні брендів акцій:", error);
        });
    },

    openCategories() {
      this.openCategory = !this.openCategory;
      document.getElementById("html").classList.toggle("hide", this.openCategory);
    },
  },
};
